import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

interface SettlementVoidReasonProps {
  voidReason: string | null;
}

const SettlementVoidReason = ({ voidReason }: SettlementVoidReasonProps) => {
  if (!voidReason) {
    return null;
  }

  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.semantic.border}`,
        borderRadius: '6px',
        backgroundColor: (theme) => theme.semantic.surfaceRaised,
        p: 2,
        minWidth: '400px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          mb: 1,
        }}
      >
        {t('approvals.driver_pay.settlements.settlements_void_reason.title')}
      </Typography>
      <Typography variant="body2">{voidReason}</Typography>
    </Box>
  );
};

export default SettlementVoidReason;
